module.exports = __webpack_public_path__ + "static/img/hover-0.0740d7fb.png";